import downloadAppFGTS from "../../assets/images/authorizationFGTS/slide-1.png";
import choose from "../../assets/images/authorizationFGTS/slide-2.png";
import accessMenu from "../../assets/images/authorizationFGTS/slide-3.png";
import authorizeConsultation from "../../assets/images/authorizationFGTS/slide-4.png";
import chooseLoan from "../../assets/images/authorizationFGTS/slide-5.png";
import chooseInstitution from "../../assets/images/authorizationFGTS/slide-6.png";
import partnerInstitution from "../../assets/images/authorizationFGTS/slide-7.png";
import partnerInstitutionNewAccount from "../../assets/images/authorizationFGTS/slide-7b.png";
import confirmAuthorization from "../../assets/images/authorizationFGTS/slide-8.png";
import returnToApp from "../../assets/images/authorizationFGTS/slide-9.png";

export const data = [
	downloadAppFGTS,
	choose,
	accessMenu,
	authorizeConsultation,
	chooseLoan,
	chooseInstitution,
	partnerInstitution,
	confirmAuthorization,
	returnToApp,
];

export const dataSecondAccount = [
	downloadAppFGTS,
	choose,
	accessMenu,
	authorizeConsultation,
	chooseLoan,
	chooseInstitution,
	partnerInstitution,
	partnerInstitutionNewAccount,
	confirmAuthorization,
	returnToApp,
];
